import {
    Text,
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    ModalFooter,
} from '@chakra-ui/react';
import { useTranslation } from 'helpers/languages/translations';

const OverwriteModal = ({ isOverwriteOpen, onOverwriteClose, handleUpload }: any) => {
    const translate = useTranslation();

    return (
        <Modal isCentered isOpen={isOverwriteOpen} onClose={onOverwriteClose} size={['sm', 'sm', '2xl']}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <Text as="h3">{translate('pictures.upload.overwrite')}</Text>
                </ModalHeader>
                <ModalCloseButton mt="2" />
                <ModalBody fontSize="sm">{translate('pictures.upload.overwrite.description')}</ModalBody>
                <ModalFooter fontSize="sm">
                    <Button onClick={handleUpload} colorScheme="blue" mr={3}>
                        {translate('pictures.upload.accept')}
                    </Button>
                    <Button onClick={onOverwriteClose}>{translate('pictures.deleteModal.cancel')}</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default OverwriteModal;
